import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IPopulateChallengeIdsBody } from './populate-challenge-ids-request';
import type { IPopulateChallengeIdsResponse } from './populate-challenge-ids-response';
import { populateChallengeIdsResponseSchema } from './populate-challenge-ids-response';

export async function populateChallengeIdsApi(
  body: IPopulateChallengeIdsBody,
): Promise<IValidatedResponse<IPopulateChallengeIdsResponse>> {
  return postRequest<IPopulateChallengeIdsResponse>({
    path: '/sys/challenges/populate/ids',
    body,
    schema: populateChallengeIdsResponseSchema,
  });
}
